import { render, staticRenderFns } from "./ScreenLaudoAmniocentese.vue?vue&type=template&id=c01d6f66&lang=true&"
import script from "./ScreenLaudoAmniocentese.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoAmniocentese.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports